export function crmSearchFieldMaterial() {
  return {
    restrict: 'E',
    template: require('./crm-search-field-material.directive.html'),
    scope: {
      entry: '=',
      organization: '<',
      onClickFn: '&onClick',
    },
    controller: controller
  };
}

controller.$inject = ['$scope'];
function controller($scope) {

}
